module.exports = "/_next/static/images/1238eb4c315b7a010458dc4b78a5180e-holding-device-smile-2@1x.jpg.webp";